"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMapAsync = void 0;
const recipes_1 = require("../recipes");
const filter_async_1 = require("./filter-async");
const has_less_or_exactly_async_1 = require("./has-less-or-exactly-async");
const basic_ingredients_async_1 = require("./basic-ingredients-async");
const partition_async_1 = require("./partition-async");
const reduce_async_1 = require("./reduce-async");
exports.toMapAsync = (0, recipes_1.toMapRecipe)({
    ...basic_ingredients_async_1.basicAsync,
    partition: partition_async_1.partitionAsync,
    filterOrAll: filter_async_1.filterAsync,
    hasLessOrExactly: has_less_or_exactly_async_1.hasLessOrExactlyAsync,
    reduce: reduce_async_1.reduceAsync,
});
